import { User } from "oidc-client";

export const userHasAllRoles = (user: User, roles: string[]): boolean => {
    const roleClaim: string | string[] = user?.profile?.role ? user.profile.role : [];
    if(Array.isArray(roleClaim)) {
        return roleClaim.every(x => roles.includes(x));        
    } else {
        return roles.length === 1 && roles.includes(roleClaim);
    }
}

export const userHasAnyRole = (user: User, roles: string[]): boolean => {
    const roleClaim: string | string[] = user?.profile?.role ? user.profile.role : [];
    if(Array.isArray(roleClaim)) {
        return roleClaim.some(x => roles.includes(x));        
    } else {
        return roles.includes(roleClaim);
    }
}